"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFixSelectedValuesOnClose = void 0;
var _react = require("react");
var useFixSelectedValuesOnClose = function useFixSelectedValuesOnClose(selectedOption, searchTerm, setSerchTermValue, closeMenu) {
  var fixSelectedValueOnClose = (0, _react.useCallback)(function () {
    if (selectedOption && searchTerm !== selectedOption.label.text) {
      // user closed the menu after changing the text
      setSerchTermValue(selectedOption.label.text);
      closeMenu();
    } else if (!selectedOption) {
      // user puts in some text but never selects
      setSerchTermValue('');
      closeMenu();
    }
  }, [closeMenu, searchTerm, selectedOption, setSerchTermValue]);
  return fixSelectedValueOnClose;
};
exports.useFixSelectedValuesOnClose = useFixSelectedValuesOnClose;